/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrganizationRequest
 */
export interface UpdateOrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    orgType?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    address?: string | null;
    /**
     * Must be a fully-qualified URL starting with http:// or https://
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrganizationRequest
     */
    notes?: string | null;
}

/**
 * Check if a given object implements the UpdateOrganizationRequest interface.
 */
export function instanceOfUpdateOrganizationRequest(value: object): value is UpdateOrganizationRequest {
    return true;
}

export function UpdateOrganizationRequestFromJSON(json: any): UpdateOrganizationRequest {
    return UpdateOrganizationRequestFromJSONTyped(json, false);
}

export function UpdateOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'orgType': json['orgType'] == null ? undefined : json['orgType'],
        'name': json['name'] == null ? undefined : json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'address': json['address'] == null ? undefined : json['address'],
        'website': json['website'] == null ? undefined : json['website'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateOrganizationRequestToJSON(json: any): UpdateOrganizationRequest {
    return UpdateOrganizationRequestToJSONTyped(json, false);
}

export function UpdateOrganizationRequestToJSONTyped(value?: UpdateOrganizationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orgType': value['orgType'],
        'name': value['name'],
        'phone': value['phone'],
        'email': value['email'],
        'address': value['address'],
        'website': value['website'],
        'notes': value['notes'],
    };
}

